import { FormatQuoteOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import { CREATE_CITATIONS } from 'common/constants/pageActions';
import { PrimaryNavigationMenuItem } from 'components/ui';

interface CreateCitationsMenuItemProps {
  disabledReason: string | null;
  onClick: () => void;
}

/**
 * Kebab-menu item for the cap-table page action. Guard failures render it
 * disabled with an explanatory tooltip rather than hiding it; the span wrapper
 * keeps the tooltip alive while the MenuItem swallows pointer events.
 */
const CreateCitationsMenuItem = ({ disabledReason, onClick }: CreateCitationsMenuItemProps) => (
  <Tooltip disableInteractive placement="left" title={disabledReason ?? ''}>
    <span>
      <PrimaryNavigationMenuItem
        disabled={Boolean(disabledReason)}
        icon={<FormatQuoteOutlined fontSize="inherit" />}
        onClick={disabledReason ? undefined : onClick}>
        {CREATE_CITATIONS}
      </PrimaryNavigationMenuItem>
    </span>
  </Tooltip>
);

export default CreateCitationsMenuItem;
